import { render, staticRenderFns } from "./NewUserTaskDialog.vue?vue&type=template&id=17dc9926&scoped=true&"
import script from "./NewUserTaskDialog.vue?vue&type=script&lang=js&"
export * from "./NewUserTaskDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dc9926",
  null
  
)

export default component.exports